export const RouteConstants = {
    NOT_FOUND: '*',
    ROOT: '',
    SIGN_IN: '/signin',
    SIGN_UP: '/signup',
    POSTS: '/posts',
}